import {
	BuildingOfficeIcon,
	DocumentTextIcon,
	FolderIcon,
	UserGroupIcon,
	WrenchIcon,
} from '@heroicons/react/24/outline';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { classNames } from '../../helpers/functions';
import { BaseDraggableWidget } from '../Card';

const items = [
	{
		name: 'Add Locations',
		description: 'Define your buildings, suites, rooms, systems, etc',
		path: '/manage/locations',
		iconColor: 'bg-gray-300',
		icon: BuildingOfficeIcon,
	},
	{
		name: 'Add Assets',
		description: 'Add your assets to your inventory',
		path: '/assets',
		iconColor: 'bg-gray-300',
		icon: FolderIcon,
	},
	{
		name: 'Manage Contracts',
		description: 'Create new or manage existing service contracts',
		path: '/manage/contracts',
		iconColor: 'bg-gray-300',
		icon: DocumentTextIcon,
	},
	{
		name: 'Manage Service Calendar',
		description: 'Manage your inventories service cycles and notifications',
		path: '/manage/tasks',
		iconColor: 'bg-gray-300',
		icon: WrenchIcon,
	},
	{
		name: 'Add Contacts',
		description: 'Keep track of all your contacts',
		path: '/manage/directory',
		iconColor: 'bg-gray-300',
		icon: UserGroupIcon,
	},
];

const SystemGetStarted = ({ title, isPreview, ...rest }) => {
	const navigate = useNavigate();

	if (isPreview) {
		return (
			<BaseDraggableWidget
				title="Get Started"
				category="App"
				description={'Quick access to setuping up your platform'}
				{...rest}
				isPreview={true}
			/>
		);
	}

	return (
		<BaseDraggableWidget
			title={'Get started'}
			widgetProps={{
				cols: 4,
			}}
			{...rest}
		>
			<div className="col-span-8">
				<ul
					role="list"
					className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-x-12 gap-y-3"
				>
					{items.map((item, itemIdx) => (
						<li
							key={itemIdx}
							className="cursor-pointer"
							onClick={() => navigate(item?.path)}
						>
							<div className="group relative flex items-start space-x-6 py-4">
								<div className="flex-shrink-0">
									<span
										className={classNames(
											item.iconColor,
											'inline-flex h-10 w-10 items-center justify-center rounded-lg'
										)}
									>
										<item.icon
											className="h-6 w-6 text-white"
											aria-hidden="true"
										/>
									</span>
								</div>
								<div className="min-w-0 flex-1">
									<div className="text-sm font-medium text-gray-900">
										<span className="absolute inset-0" aria-hidden="true" />
										{item.name}
									</div>
									<p className="text-xs text-gray-500">{item.description}</p>
								</div>
							</div>
						</li>
					))}
				</ul>
			</div>
		</BaseDraggableWidget>
	);
};
export default SystemGetStarted;
